import { useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { useTranslation } from 'react-i18next';
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { serviceData } from "../../constants/data"
import { Link } from "react-router-dom";
// import settings from "../../constants/settings";

gsap.registerPlugin(ScrollTrigger)

const Service = () => {

  const serviceRefs = useRef([])
  const containerRef = useRef(null)
  const { t } = useTranslation();

  const addToRefs = (el) => {
    if (el && !serviceRefs.current.includes(el)) {
      serviceRefs.current.push(el)
    }
  }

  useEffect(() => {
    gsap.set(serviceRefs.current, { opacity: 0, y: 50 });

    const ctx = gsap.context(() => {
      serviceRefs.current.forEach((el, index) => {
        gsap.to(el, {
          y: 0,
          opacity: 1,
          duration: 0.8,
          delay: index * 0.1,
          ease: "power2.out",
          paused: true, // Start paused and let ScrollTrigger control it
          scrollTrigger: {
            trigger: el,
            start: "top 85%",  // Slightly higher trigger point
            end: "bottom 20%",
            // toggleActions: "play reverse play reverse", // Enables both directions
            toggleActions: "play none none reset", // Enables both directions
            // onLeave: () => animation.reverse(),
            // onEnterBack: () => animation.play(),
            // onLeaveBack: () => animation.reverse(),
            // markers: false // Set to true to debug positions
          }
        });
      });
    }, containerRef);

    // Refresh ScrollTrigger on resize
    const handleResize = () => ScrollTrigger.refresh();
    window.addEventListener('resize', handleResize);

    return () => {
      ctx.revert();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className="md:w-theme-container w-mobile-container mx-auto my-20 mt-40"
    >
      <div
        ref={addToRefs}
        className="text-left md:text-center text-2xl"
      >{t('common.services')}</div>
      <div className="flex justify-end items-center">
        <div
          ref={addToRefs}
          className="md:text-xl text-base my-10 md:mt-20 text-justify md:w-[40%] "
        >
          {t('common.serviceDescription')}
        </div>
      </div>

      <div className="grid md:grid-cols-4 grid-cols-1 mt-18 gap-12">
        {serviceData.map((service, index) => (
          <div
            key={service.id}
            ref={addToRefs}
            className={`relative flex flex-col items-center justify-start`}
            style={window.innerWidth >= 768 ? { marginTop: `${index * 80}px` } : {marginTop: `40px`}}
          >
            {/* Circle Image */}
            <div className="w-36 h-36 bg-white rounded-full absolute -top-20 flex items-center justify-center">
              <img
                src={require(`../../assets/images/services/${service.imgName}`)}
                alt={service.title}
                className="w-24 h-24 object-contain"
              />
            </div>
            {/* Card Content */}
            <Link
              // to={`${settings.domain}/${service.routeLink}`}
              to={service.routeLink}
              className={`group w-full  rounded-xl p-6 cursor-pointer overflow-hidden ${
                index % 2 === 0 ? "bg-theme-color hover:bg-white hover:border-4 hover:border-theme-color" : "border-4 border-theme-color hover:bg-theme-color"
              } text-center flex flex-col items-center`}
            >
              <div
                className={`text-base font-bold mt-10 ${index % 2 === 0 ? "text-white group-hover:text-theme-color" : "text-theme-color group-hover:text-white"}`}
              >
                {t(`serviceCards.titles.${index}`)}
              </div>
              <div
                className={`text-sm ${index % 2 === 0 ? "text-white group-hover:text-theme-color" : "text-theme-color group-hover:text-white"} mt-8`}
              >
                {t(`serviceCards.descriptions.${index}`)}
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Service
